import type { ReactNode } from 'react'
import React from 'react'
import { useLocalisation } from '@/tools/i18n/client'

interface TranslatorProps {
  keyText: string
  params?: Record<string, ReactNode>
}

export const Translator: React.FC<TranslatorProps> = ({ keyText, params = {} }) => {
  const { t } = useLocalisation()
  const translation = t(keyText)

  const parts = translation.split('{').flatMap((part) => part.split('}'))

  const missingParams = parts.filter(
    (part) => translation.includes(`{${part}}`) && !params.hasOwnProperty(part)
  )

  if (missingParams.length > 0) {
    throw new Error(
      `Missing parameters: ${missingParams.join(', ')} in translation key: ${keyText}`
    )
  }

  return (
    <>
      {parts.map((part, index) => (
        <React.Fragment key={index}>
          {params.hasOwnProperty(part) ? params[part] : part}
        </React.Fragment>
      ))}
    </>
  )
}
